// extracted by mini-css-extract-plugin
export var auto = "_3a-1";
export var spinner = "_3a-0";